import { render } from "./ContasPagar.vue?vue&type=template&id=1097bd4e"
import script from "./ContasPagar.vue?vue&type=script&lang=js"
export * from "./ContasPagar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__